import React, { Component } from "react";
import { withNamespaces } from "react-i18next";

//Components
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
import AgentComission from "./AgentComission";
import CommisionSimulator from "./CommisionSimulator";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { TabContainer, Nav, NavItem, NavLink, TabContent, TabPane } from 'react-bootstrap'

class CommissionIllustrate extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = {};
    }

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        const { t } = this.props;
        return (
            <Auxiliary>
                <section className="pf-m-dashboard comission">
                    <MobileSubHeader
                        className="bg-white"
                        returnPage="/"
                        header={t('sidebar.commission-illustrate')}
                        modalHeader={true}
                        modalHandler={this.toggleModal}
                    />
                    <TabContainer defaultActiveKey="agent_commission">
                        <Nav className='mobile delegate-deposit-nav' variant="pills">
                            <NavItem>
                                <NavLink eventKey="agent_commission" id="agent_commission" onClick={(event) => this.props.changeTabHandler(event)}>{t('commission-illustrate.agent-commission-details')}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink eventKey="commission_simulator" id="commission_simulator" onClick={(event) => this.props.changeTabHandler(event)}>{t('commission-illustrate.commission-simulator')}</NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent className='tab-content-container'>
                            <TabPane eventKey="agent_commission">
                                <div className="pd-m-card-col">
                                    <div className="rh-m-pd-card">
                                        <AgentComission 
                                            {...this.state}
                                            {...this.props}
                                        />
                                    </div>
                                </div>
                            </TabPane>
                            <TabPane eventKey="commission_simulator">
                                <CommisionSimulator 
                                    {...this.state}
                                    {...this.props}
                                />
                            </TabPane>
                        </TabContent>
                    </TabContainer>
                </section>
            </Auxiliary>
        )
    }
}

export default withNamespaces("translation")(CommissionIllustrate);